import React from 'react';
import { getGatewayTwinStatusClassName } from './summaryDisplayUtils';

export type GatewayStatusModalState = {
  assetName: string;
  status: string;
  loading: boolean;
  error: string | null;
};

type Props = {
  state: GatewayStatusModalState;
  onClose: () => void;
};

const SummaryGatewayStatusModal: React.FC<Props> = ({ state, onClose }) => (
  <div
    className="modal-overlay-gateway-status"
    onClick={(e) => {
      if (e.target === e.currentTarget) onClose();
    }}
    onKeyDown={(e) => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target === e.currentTarget) {
        e.preventDefault();
        onClose();
      }
    }}
    role="presentation"
  >
    <div className="modal-content-gateway-status gateway-status-modal">
      <div className="modal-header">
        <h3>Gateway Status</h3>
        <button className="modal-close-btn" onClick={onClose} type="button">
          ×
        </button>
      </div>
      <div className="modal-body">
        <div className="gateway-status-details">
          <p><strong>Asset Name:</strong> {state.assetName}</p>
          {state.loading && <p>Loading gateway status...</p>}
          {!state.loading && state.error && <p>{state.error}</p>}
          {!state.loading && !state.error && (
            <div className={`summary-status ${getGatewayTwinStatusClassName(state.status)}`}>
              <p className="status-text">{state.status}</p>
            </div>
          )}
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn-secondary" onClick={onClose} type="button">
          Close
        </button>
      </div>
    </div>
  </div>
);

export default SummaryGatewayStatusModal;
